<template>
  <div>
    <registrations-numbers-add
      :is-active="isModalActive"
      :customer-id="Number(this.$route.params.id)"
      :is-add="isAdd"
      :action="action"
      :edit-object-name="editObjectName"
      @confirm="editConfirm"
      @cancel="editCancel"
    />
    <registration-numbers-upload
      :is-active="uploadRegNumVisible"
      :customer-id="Number(this.$route.params.id)"
      @close="uploadRegNumVisible = false"
      @confirm="editConfirm"
    />

    <div class="level no-margin">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item-horizontal">
          <ul class="context-options-right">
            <li v-if="disableActionItem()">
              <a @click.prevent="addModal">Add new</a>
            </li>
            <li v-if="disableActionItem()">
              <a
                @click.prevent="uploadRegistrationNumbers"
                data-cy="import-registration-number"
                >Import</a
              >
            </li>
            <li>
              <a
                @click.prevent="exportRegistrationNumbers"
                data-cy="export-registration-number"
                >Export selected</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div>
      <circul8-table
        :records="data"
        :fields="columns"
        :routeNext="false"
        :usePropRecords="true"
        @clickcheck="checkCheckBox"
        @clickEdit="editModal"
        @clickView="viewModal"
        @clickDelete="deleteModal"
        :showRemoveButton="showDelete"
        :showEditButton="showEdit"
        :isCheckable="true"
      />
    </div>
  </div>
</template>

<script>
import RegistrationNumberService from "@/services/RegistrationNumberService";
import RegistrationNumbersUpload from "@/components/Customers/RegistrationNumbersUpload.vue";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import Circul8Table from "../../components/Circul8Table.vue";
import utilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import { Permission } from "../../services/Permissions";
import { mapGetters } from "vuex";
import RegistrationsNumbersAdd from "./RegistrationsNumbersAdd.vue";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
// @group Customers
export default {
  name: "RegistrationNumbersView",
  mixins: [utilityMixin, ScopeMixin, UserPermissionMixin],
  components: {
    RegistrationNumbersUpload,
    Circul8Table,
    RegistrationsNumbersAdd
  },

  props: {
    checkable: {
      type: Boolean,
      default: false
    },
    contactAction: {
      type: Boolean,
      default: false
    },
    customerAccountManager: {
      type: Number,
      default: 0
    },
    backupCustomerAccountManager: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isModalActive: false,
      uploadRegNumVisible: false,
      isAdd: false,
      action: null,
      editObject: this.getClearFormObject(),
      tableHeight: "",
      users: [],
      checkedRow: [],
      data: [],

      customers: [],
      customerMap: {},
      containerMap: {},
      countryMap: {},
      schemeMap: {},
      columns: [
        {
          field: "customer",
          label: "Customer"
        },
        {
          field: "country",
          label: "Country"
        },
        {
          field: "stream",
          label: "Stream"
        },
        {
          field: "scheme",
          label: "Scheme"
        },
        {
          field: "registration_no",
          label: "Registration Number with Legal Obligation"
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions"
        }
      ],
      registrationNumberService: new RegistrationNumberService(),
      customerDataService: new CustomerProfileDataService()
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "switchCustomerView"
    ]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    }
  },
  watch: {
    customerAccountManager(newValue) {
      //Watches value of CAM and triggers this function if value of CAM changes
      this.fetchRegistrationNumberData();
    },
    customers(newValue) {
      this.fetchCustomerList(newValue);
    }
  },
  mounted() {
    if (!this.userExternalCheck() && !this.switchCustomerView) {
      this.isExternal = false;
      const popped = this.columns.pop();
      this.columns.push({
        field: "membership_no_with_scheme",
        label: "Membership Number with Scheme / Authority"
      });
      this.columns.push({
        field: "additional_info",
        label: "Additional Information",
        class: "enable-select-text"
      });
      this.columns.push(popped);
    } else {
      this.isExternal = true;
    }
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
      this.fetchCustomerProfileData(this.switchCustomerId, true);
    } else {
      this.fetchCustomerProfileData();
    }
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.fetchRegistrationNumberData();
  },

  methods: {
    checkCheckBox(d) {
      this.checkedRow = d;
    },

    getClearFormObject() {
      return {
        id: null,
        customer: Number(this.$route.params.id),
        country: null,
        scheme: null,
        stream: null,
        additional_info: "",
        registration_no: "",
        membership_no_with_scheme: ""
      };
    },
    addModal() {
      this.isAdd = true;
      this.action = "Add";
      this.editObject = this.getClearFormObject();
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.isAdd = true;
      this.action = "Update";
      this.fetchRegistrationNumberSingleData(editObject);
      this.isModalActive = true;
    },
    viewModal(editObject) {
      this.isAdd = false;
      this.action = "View";
      this.fetchRegistrationNumberSingleData(editObject);
      this.isModalActive = true;
    },
    deleteModal(editObject) {
      this.isAdd = false;
      this.action = "Delete";
      this.fetchRegistrationNumberSingleData(editObject);
      this.isModalActive = true;
    },
    editConfirm(response) {
      this.fetchRegistrationNumberData();
      this.isModalActive = false;
      this.checkedRow = [];
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    exportRegistrationNumbers() {
      let switchCustomer = false;
      if (this.switchCustomerView) {
        switchCustomer = true;
      }
      try {
        const set = new Set(
          this.checkedRow.map(cc => cc.id).map(result => JSON.stringify(result))
        );
        this.registrationNumberService.export(
          Array.from(set).map(elem => JSON.parse(elem)),
          Number(this.$route.params.id),
          switchCustomer
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Upload Error !!!",
          message: e.message,
          type: "is-danger",
          hasIcon: true,
          icon: "times-circle",
          iconPack: "fa",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    uploadRegistrationNumbers() {
      this.uploadRegNumVisible = true;
    },

    fetchCustomerList(customers) {
      this.customerMap = this.prepareMasterData(customers);
    },
    prepareData(data) {
      for (const report in data) {
        data[report]["customer"] = this.customerMap[data[report].customer];
        data[report]["country"] = this.countryMap[data[report].country];
        data[report]["stream"] = this.containerMap[data[report].stream];
        data[report]["scheme"] = this.schemeMap[data[report].scheme];
        data[report]["actions"] = this.isEditAllowed();
        data[report]["delete"] = this.isEditAllowed();
      }
      this.data = data;

      if (this.data.length >= 10) {
        this.tableHeight = "height:560px";
      }
    },
    prepareMasterData(data) {
      const resultDict = {};
      for (const idx in data) {
        const dataDict = data[idx];
        resultDict[dataDict["id"]] = dataDict["name"];
      }
      return resultDict;
    },
    handleApiError(reason) {
      const errorMessage = reason.response.data["detail"];

      if (errorMessage != null && errorMessage != undefined) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: errorMessage,
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    fetchRegistrationNumberSingleData(editObjectName) {
      this.registrationNumberService
        .getAll(this.$route.params.id, editObjectName.id)
        .subscribe(response => {
          this.editObject = response;
        }, this.handleApiError);
    },
    isEditAllowed() {
      if (this.$route.fullPath.includes("/view/")) {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) ||
        (this.userHasPermission(Permission.CUSTOMER_PROFILE_CHANGE_CAM) &&
          (this.customerAccountManager == this.userId ||
            this.backupCustomerAccountManager == this.userId))
      ) {
        this.showDelete = true;
        this.showEdit = true;
        return true;
      } else {
        this.showDelete = false;
        this.showEdit = false;
        return false;
      }
    },
    fetchRegistrationNumberData() {
      this.isLoading = true;
      this.registrationNumberService
        .getAll(this.$route.params.id)
        .subscribe(response => {
          this.isLoading = false;
          this.prepareData(response);
        }, this.handleApiError);
    }
  }
};
</script>
